import { Link } from 'react-router-dom';

interface Props {
  title: string;
  body?: string;
  secondary?: { label: string; to: string };
}

export default function CTASection({ title, body, secondary }: Props) {
  return (
    <section className="max-w-[1200px] mx-auto px-5 md:px-10 pb-20 md:pb-28">
      <div className="border-t border-background-200 pt-14 md:pt-20 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
        <div>
          <h2 data-mo="title" className="h-section text-foreground-950 max-w-3xl">{title}</h2>
          {body && <p className="mt-5 t-body text-foreground-600 max-w-lg">{body}</p>}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          {secondary && (
            <Link to={secondary.to} className="inline-flex justify-center items-center gap-2 border border-foreground-950/70 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 font-label text-xs tracking-[0.12em] uppercase px-7 h-[52px] rounded-md transition-colors cursor-pointer whitespace-nowrap">
              {secondary.label}
            </Link>
          )}
          <Link to="/request-quote" className="inline-flex justify-center items-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-label text-xs tracking-[0.12em] uppercase px-7 h-[52px] rounded-md transition-colors cursor-pointer whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2">
            Request a Quote <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}